
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import GoogleAnalytics from '../components/GoogleAnalytics';



function Tatawingeronrentinpune() {



  const cardData =
  {
    keyword: 'Tata Winger On Rent in Pune',
    heading: 'SHREE Tours & Travels: Tata Winger On Rent in Pune',
    headingDescription: 'SHREE Tours & Travels offers Tata Winger on rent in Pune, providing a spacious and comfortable travel experience for group tours, corporate trips, family outings and airport transfers. Whether you need a vehicle for one-way travel, round trips, weekend getaways, or outstation journeys, our well-maintained Tata Winger ensures a smooth and hassle-free ride. With ample seating capacity, professional drivers and affordable pricing, we guarantee a convenient and reliable travel experience. Choose SHREE Tours & Travels for the best Tata Winger rental service in Pune.',

    top: 'Top Places to Visit in Pune with SHREE Tours & Travels',
"topPlaces": [
    {
        "title": "Shaniwar Wada",
        "description": "Shaniwar Wada is a historic fortification built in 1732 and served as the seat of the Peshwas of the Maratha Empire. This grand palace is known for its majestic entrance, intricate wooden carvings and sprawling gardens. Despite being largely destroyed by a fire in 1828, its ruins still stand as a reminder of Pune’s glorious past. Visitors can explore the remains of the palace, enjoy the light and sound show in the evening and learn about the legends of the fort, including its famous haunted stories."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892 by Sultan Muhammed Shah Aga Khan III, Aga Khan Palace is a significant historical landmark. It played a crucial role in India's independence movement, as Mahatma Gandhi, Kasturba Gandhi and Mahadev Desai were imprisoned here during the Quit India Movement. The palace now serves as a museum with rare photographs, personal belongings of Gandhi and an eternal flame in honor of freedom fighters. The Italian-style architecture and beautifully maintained gardens make it a peaceful and educational visit."
    },
    {
        "title": "Sinhagad Fort",
        "description": "Situated on a hilltop, Sinhagad Fort is an iconic landmark known for its historical significance and breathtaking views. The fort was the site of the famous Battle of Sinhagad in 1670, where Tanaji Malusare, a brave Maratha warrior, fought for Chhatrapati Shivaji Maharaj. It is a popular trekking destination, offering a rewarding climb with stunning views of the Sahyadri mountains. Visitors can enjoy local Maharashtrian delicacies like pithla-bhakri and kanda bhaji at small eateries near the fort."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "An ancient rock-cut temple dedicated to Lord Shiva, the Pataleshwar Cave Temple dates back to the 8th century. The temple is carved from a single basalt rock and features massive pillars, intricate sculptures and a Nandi (bull) statue. Its unique architecture and serene ambiance make it a fascinating place for history and spirituality enthusiasts. The temple offers a peaceful escape from the bustling city and is an ideal spot for meditation."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "The Raja Dinkar Kelkar Museum is a treasure trove of India’s cultural heritage, featuring over 20,000 artifacts collected by Dr. Dinkar Kelkar. The museum showcases a diverse collection of ancient musical instruments, traditional weapons, sculptures, paintings and beautifully carved doors. One of its highlights is the ‘Mastani Mahal,’ a reconstructed palace of Bajirao Peshwa’s beloved queen. This museum provides a captivating insight into India’s artistic and historical richness."
    },
    {
        "title": "Pashan Lake",
        "description": "Pashan Lake is an artificial lake that attracts nature lovers and birdwatchers. It is home to various migratory birds, making it a paradise for photographers and wildlife enthusiasts. The lake has a well-maintained walking track, making it a great spot for morning and evening strolls. The tranquil surroundings and fresh air offer a refreshing break from the city's hustle and bustle."
    },
    {
        "title": "Osho Ashram",
        "description": "Located in Koregaon Park, the Osho International Meditation Resort is one of the world’s most famous spiritual centers. It offers various meditation programs, yoga sessions and wellness therapies, attracting visitors from across the globe. The ashram promotes a unique blend of Eastern and Western spiritual practices. Visitors can also explore the beautifully landscaped Osho Teerth Park nearby, making it a great place for relaxation and self-discovery."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "Dagdusheth Halwai Ganpati Temple is one of Pune’s most revered temples, attracting thousands of devotees. The temple is dedicated to Lord Ganesha and features a magnificent idol adorned with gold and jewels. During the Ganesh Chaturthi festival, the temple becomes a major attraction with grand celebrations and processions. The temple’s divine ambiance and spiritual significance make it a must-visit for religious and cultural travelers."
    },
    {
        "title": "Rajiv Gandhi Zoological Park",
        "description": "Spread across 130 acres, the Rajiv Gandhi Zoological Park consists of a zoo, a snake park and a wildlife rescue center. It houses a variety of animals, including tigers, leopards, crocodiles and elephants. The snake park is one of its major attractions, featuring different species of snakes and reptiles. The well-maintained environment and educational exhibits make it an excellent place for family outings and nature lovers."
    },
    {
        "title": "Khadakwasla Dam",
        "description": "Khadakwasla Dam is a popular weekend getaway located on the Mutha River. It serves as the primary water source for Pune and is surrounded by picturesque hills and lush greenery. Visitors can enjoy breathtaking sunset views, take leisurely walks along the dam, or relish street food like vada pav and roasted corn from local vendors. The nearby Sinhagad Fort and Panshet Dam add to its appeal, making it a perfect one-day picnic spot."
    }
],  
    
            
"services": [
    {
      "name": "Tata Winger Car Rental Pune",
      "description": "Rent a Tata Winger in Pune for a spacious and comfortable ride. Known for its versatility and roomy interiors, the Tata Winger is perfect for group travel, family trips and outstation journeys."
    },
    {
      "name": "Rent Tata Winger in Pune",
      "description": "Book a Tata Winger in Pune for a comfortable travel experience. Whether it’s for group outings, family vacations, or corporate events, enjoy ample space and a smooth ride."
    },
    {
      "name": "Tata Winger for Outstation Travel Pune",
      "description": "Travel to outstation destinations in comfort by renting a Tata Winger from Pune. Its spacious interiors and reliable performance make it ideal for long-distance travel with family or a group."
    },
    {
      "name": "Tata Winger for Group Travel Pune",
      "description": "Hire a Tata Winger for group travel in Pune. With generous seating capacity and ample luggage space, it’s the perfect vehicle for group tours, outings and corporate travel."
    },
    {
      "name": "Affordable Tata Winger Hire Pune",
      "description": "Looking for an affordable yet comfortable ride? Rent a Tata Winger in Pune and enjoy a cost-effective travel option with plenty of space for passengers and luggage."
    },
    {
      "name": "Book Tata Winger for Family Travel Pune",
      "description": "Book a Tata Winger for a family trip in Pune. With spacious seating and plenty of room for luggage, it’s the ideal vehicle for family vacations or long-distance journeys."
    },
    {
      "name": "Tata Winger Rental for Corporate Events Pune",
      "description": "For corporate events, rent a Tata Winger in Pune. It offers ample space for employees or clients and ensures comfortable and safe transportation to and from corporate events."
    },
    {
      "name": "Rent Tata Winger for Business Travel Pune",
      "description": "Make your business trips more comfortable by renting a Tata Winger in Pune. With plenty of space for work or relaxation, it’s perfect for professionals traveling with colleagues or clients."
    },
    {
      "name": "Tata Winger Hire for Airport Pickup Pune",
      "description": "Book a Tata Winger for a comfortable and convenient airport pickup in Pune. With its spacious interiors and professional service, it’s the ideal choice for your airport transfer needs."
    },
    {
      "name": "Tata Winger for Weekend Trip Pune",
      "description": "Hire a Tata Winger for your weekend getaway from Pune. Whether you’re heading for a short vacation or a group trip, enjoy ample space and comfort on your journey."
    },
    {
      "name": "Luxury Tata Winger Hire Pune",
      "description": "Experience the luxury of a Tata Winger for your travel needs in Pune. With plush interiors and plenty of space, this vehicle provides a comfortable and premium ride for long trips or special occasions."
    }
  ],
  "tableData": [
    ["- Tata Winger Car Rental Pune", "- Rent Tata Winger in Pune"],
    ["- Tata Winger for Outstation Travel Pune", "- Tata Winger for Group Travel Pune"],
    ["- Affordable Tata Winger Hire Pune", "- Book Tata Winger for Family Travel Pune"],
    ["- Tata Winger Rental for Corporate Events Pune", "- Rent Tata Winger for Business Travel Pune"],
    ["- Tata Winger Hire for Airport Pickup Pune", "- Tata Winger for Weekend Trip Pune"],
    ["- Luxury Tata Winger Hire Pune"]
  ],

  whychoose: [
    {
      "WhyChooseheading": "Spacious and Comfortable Travel",
      "WhyChoosedescription": "The Tata Winger offers a spacious, comfortable and practical solution for group travel. With ample seating for up to 12 passengers, it’s perfect for family trips, group outings, or corporate travel in Pune. Enjoy the generous legroom, large windows and air conditioning for a pleasant and relaxing journey."
    },
    {
      "WhyChooseheading": "Perfect for Group and Family Travel",
      "WhyChoosedescription": "With its seating capacity of up to 12 passengers, the Tata Winger is ideal for group and family travel. Whether you're planning a road trip, a weekend getaway, or a corporate outing, this vehicle ensures everyone travels comfortably with plenty of space for luggage and personal belongings."
    },
    {
      "WhyChooseheading": "Well-Maintained and Safe Vehicles",
      "WhyChoosedescription": "We ensure that all our Tata Winger vehicles are meticulously maintained and regularly serviced to ensure optimal performance and safety. Each vehicle undergoes a thorough inspection for cleanliness, mechanical reliability and safety, giving you peace of mind as you travel."
    },
    {
      "WhyChooseheading": "Experienced and Professional Drivers",
      "WhyChoosedescription": "Our drivers are highly experienced, professional and dedicated to providing a smooth and safe ride. Familiar with the best routes in Pune, they prioritize punctuality and safety while ensuring a comfortable and hassle-free journey for all passengers."
    },
    {
      "WhyChooseheading": "Ideal for Group Travel and Outings",
      "WhyChoosedescription": "The Tata Winger is perfect for group travel in Pune, whether you're heading to a business event, a family reunion, or a group tour. Offering both comfort and practicality, the Winger ensures that everyone travels together without sacrificing space or comfort."
    },
    {
      "WhyChooseheading": "Hassle-Free Booking Process",
      "WhyChoosedescription": "Booking the Tata Winger with SHREE Tours & Travels is quick and simple. You can easily reserve your vehicle online through our user-friendly platform or contact our customer service team for personalized assistance, ensuring a smooth and hassle-free booking experience."
    },
    {
      "WhyChooseheading": "24/7 Availability",
      "WhyChoosedescription": "We offer 24/7 availability for Tata Winger rentals in Pune. Whether it’s a last-minute booking or a planned trip, we are ready to accommodate your travel needs at any time, ensuring you have access to a reliable and spacious vehicle whenever you need it."
    },
    {
      "WhyChooseheading": "Customer Satisfaction Guarantee",
      "WhyChoosedescription": "At SHREE Tours & Travels, we prioritize customer satisfaction. We are committed to providing exceptional service and ensuring that every Tata Winger rental meets the highest standards of comfort, safety and reliability. Our goal is to deliver a seamless, enjoyable and stress-free travel experience."
    }
  ]
  
  
  
  

  
  
  
  
  

  
  



        
  }
  const faqData = [
    {
        question: "How can I rent a Tata Winger in Pune?",
        answer: "You can easily rent a Tata Winger in Pune through our website or by contacting our customer service for assistance."
    },
    {
        question: "What is the rental rate for a Tata Winger in Pune?",
        answer: "The rental rate for a Tata Winger varies depending on the duration and type of trip. Please contact us for detailed pricing information."
    },
    {
        question: "Is the rental rate for the Tata Winger inclusive of fuel?",
        answer: "Fuel charges may vary depending on the rental agreement. We provide detailed pricing information during the booking process."
    },
    {
        question: "Can I rent a Tata Winger for a one-way trip in Pune?",
        answer: "Yes, we offer one-way rental options for the Tata Winger for trips within Pune or to nearby cities."
    },
    {
        question: "Do you provide drivers with the Tata Winger rental in Pune?",
        answer: "Yes, all our Tata Winger rentals come with experienced drivers who are familiar with the local routes to ensure a safe and comfortable journey."
    },
    {
        question: "What is your cancellation policy for Tata Winger bookings in Pune?",
        answer: "We offer a flexible cancellation policy. Please contact us for detailed information specific to your booking."
    },
    {
        question: "What payment methods do you accept for renting a Tata Winger in Pune?",
        answer: "We accept various payment methods, including cash, credit/debit cards and mobile wallets for your convenience."
    },
    {
        question: "Are the Tata Winger vehicles insured for safety during trips in Pune?",
        answer: "Yes, all our Tata Winger vehicles are fully insured for your safety and peace of mind during the journey."
    },
    {
        question: "Can I request a child seat for my Tata Winger rental in Pune?",
        answer: "Yes, child seats can be arranged upon request at the time of booking."
    },
    {
        question: "What is your contact information for renting a Tata Winger in Pune?",
        answer: "For bookings and inquiries, you can reach us at: +91 9594917913."
    }
];

const testimonialsData = [
    {
        text: 'I rented a Tata Winger from SHREE Tours & Travels for a group trip in Pune. The vehicle was spacious and comfortable and the driver was friendly and professional.',
        name: 'Mr. Sanjay Joshi',
    },
    {
        text: 'Our family trip in Pune was made more enjoyable with the Tata Winger from SHREE Tours & Travels. The car was clean, well-maintained and the driver made the trip smooth and safe.',
        name: 'Miss. Priya Shinde',
    }
];



















  
  
  


  


  const contactData = {
     heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9594917913",

    ],
    email: "booking@shreecabs24.com"
  };


    const Images = [
    {
        place: "/images/keyword/1.jpg",
        text: "Pune to Kolhapur Cab",
        link: "/Pune-to-Kolhapur-Cab",
    },
    {
        place: "/images/keyword/2.jpg",
        text: "Pune to Mumbai Cab",
        link: "/Pune-to-Mumbai-Cab",
    },
    {
        place: "/images/keyword/3.jpg",
        text: "Pune to Sangli Cab",
        link: "/Pune-to-Sangli-Cab",
    },
    {
        place: "/images/keyword/4.jpg",
        text: "Pune to Mahabaleshwar Cab",
        link: "/Pune-to-Mahabaleshwar-Cab",
    },
    {
        place: "/images/keyword/5.jpg",
        text: "Pune to Bhimashankar Cab",
        link: "/Pune-to-Bhimashankar-Cab",
    },
    {
        place: "/images/keyword/6.jpg",
        text: "Pune to Shirdi Cab",
        link: "/Pune-to-Shirdi-Cab",
    },
    {
        place: "/images/keyword/7.jpg",
        text: "Pune to Nashik Cab",
        link: "/Pune-to-Nashik-Cab",
    },
    {
        place: "/images/keyword/8.jpg",
        text: "Pune Airport Pickup and Drop",
        link: "/Pune-Airport-Pickup-and-Drop",
    },
    {
        place: "/images/keyword/9.jpg",
        text: "Pune To Mumbai Airport Cab",
        link: "/Pune-To-Mumbai-Airport-Cab",
    },
    {
        place: "/images/keyword/10.jpg",
        text: "Mumbai To Pune Cab",
        link: "/Mumbai-To-Pune-Cab",
    },
    {
        place: "/images/keyword/12.jpg",
        text: "Mumbai To Kolhapur Cab",
        link: "/Mumbai-To-Kolhapur-Cab",
    },
    {
        place: "/images/keyword/13.jpg",
        text: "Mumbai To Shirdi Cab",
        link: "/Mumbai-To-Shirdi-Cab",
    },
    {
        place: "/images/keyword/14.jpg",
        text: "Mumbai To Nashik Cab",
        link: "/Mumbai-To-Nashik-Cab",
    },
    {
        place: "/images/keyword/15.jpg",
        text: "Mumbai Airport To Pune Cab",
        link: "/Mumbai-Airport-To-Pune-Cab",
    },
    {
        place: "/images/keyword/16.jpg",
        text: "Kolhapur To Pune Cab",
        link: "/Kolhapur-To-Pune-Cab",
    },
    {
        place: "/images/keyword/17.jpg",
        text: "Kolhapur To Mumbai Cab",
        link: "/Kolhapur-To-Mumbai-Cab",
    },
    {
        place: "/images/keyword/18.jpg",
        text: "Sangli To Pune Cab",
        link: "/Sangli-To-Pune-Cab",
    },
    {
        place: "/images/keyword/19.jpg",
        text: "One Way Taxi in Pune",
        link: "/One-Way-Taxi-in-Pune",
    },
    {
        place: "/images/keyword/20.jpg",
        text: "Best Cab service in Pune",
        link: "/Best-Cab-Service-in-Pune",
    },
    {
        place: "/images/keyword/21.jpg",
        text: "Outstation Cabs Pune",
        link: "/Outstation-Cabs-Pune",
    },
    {
        place: "/images/keyword/22.jpg",
        text: "Swift Dzire Hire in Pune",
        link: "/Swift-Dzire-Hire-in-Pune",
    },
    {
        place: "/images/keyword/23.jpg",
        text: "Xcent Hyundai On Rent in Pune",
        link: "/Xcent-Hyundai-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/24.jpg",
        text: "Nexa Ciaz On Rent in Pune",
        link: "/Nexa-Ciaz-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/25.jpg",
        text: "Honda City On Rent In Pune",
        link: "/Honda-City-On-Rent-In-Pune",
    },
    {
        place: "/images/keyword/26.jpg",
        text: "Ertiga On Rent in Pune",
        link: "/Ertiga-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/27.jpg",
        text: "Innova Cab for Outstation in Pune",
        link: "/Innova-Cab-for-Outstation-in-Pune",
    },
];

  
const images = [
    { src: "/images/ourfleet/1.webp", alt: "Image 1" },
    { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Tata Winger On Rent in Pune",
  "description": "Rent a Tata Winger in Pune with S9 Travels for a comfortable and affordable group travel experience. Whether for outstation trips, corporate events, family vacations, or weekend getaways, our Tata Winger rental services ensure a smooth journey. Book a Tata Winger for business travel, airport pickups, or group trips, and enjoy a spacious and luxurious ride.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.6",
    "ratingCount": "945"
  }
};


  return (
    <div>
      <GoogleAnalytics/>
    <Helmet>
  <title>Tata Winger On Rent in Pune | SHREE Tours & Travels | Call: +91 9594917913</title>
  <meta name="description" content="Rent a Tata Winger in Pune for comfortable group travel, family trips, business events and outstation travel. Book now for affordable and luxury Tata Winger hire services. Ideal for corporate events, weekend trips and airport pickups." />
  <meta name="keywords" content="Tata Winger Car Rental Pune, Rent Tata Winger in Pune, Tata Winger for Outstation Travel Pune, Tata Winger for Group Travel Pune, Affordable Tata Winger Hire Pune, Book Tata Winger for Family Travel Pune, Tata Winger Rental for Corporate Events Pune, Rent Tata Winger for Business Travel Pune, Tata Winger Hire for Airport Pickup Pune, Tata Winger for Weekend Trip Pune, Luxury Tata Winger Hire Pune" />
  <meta name="robots" content="index, follow" />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


    <section
        className="page-title"
        style={{ backgroundImage: 'url(images/hero.jpg)' }}
      >
        <div className="auto-container">
          <div className="title-outer text-center">
            <h1 className="title">{cardData.keyword} </h1>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
         <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/34.jpg' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#0310a8', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <div className='pb-3'>
                <button
                  className="p-3 text-white fw-bold borderrr bg-header"
                  onClick={() => {
                    window.location.href = '/booking';
                  }}
                >
                  Book Your Cab
                </button>
              </div>
              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
            <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for SHREE Tours & Travels </h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                {/* <CustomCarousel items={carouselItems} options={carouselOptions} /> */}

                <TestimonialKeyword testimonials={testimonialsData} />

                
              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
    {Images.map((e) => {
        return (
            <div className="box1">
                <a href={e.link} className="d-flex justify-content-around align-items-center">
                    <div className="b1">
                        <img src={e.place} alt="img" />
                    </div>
                    <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                    </div>
                </a>
            </div>
        );
    })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Fleet</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
               
                </div>
              </div>

             <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #0310a8',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#0310a8' }}>
                      <div>
                      <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>
                      
                      <div className=''>
                        <a href="tel:+919594917913" className="d-block  text-white">
                        <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 9594917913
                      </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      
                      <div className='rounded ' style={{ backgroundColor: '#0310a8' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:booking@shreecabs24.com" className=" text-white d-block">
                        <i className="fas fa-envelope darkcolorrr"></i> booking@shreecabs24.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      
                      <div className='rounded ' style={{ backgroundColor: '#0310a8' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                        <i className="fas fa-map-marker-alt darkcolorrr"></i>  SHREE Tours & Travels<br />
                          Maharashtra Co-Operative Housing Society,
                          Yerawada, Pune, Maharashtra India - 411006
                            
                         
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Tatawingeronrentinpune;